import { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';

const CardTerminal = observer((props) => {
  const {
    data,
    event,
  } = props;

  return (
    <div
      className="px-24px pr-16px mr-4px my-16px text-[14px] leading-[24px] break-words overflow-x-hidden overflow-y-auto scrollbar"
      dangerouslySetInnerHTML={{ __html : data }}
    ></div>
  )
});

export default CardTerminal;